import { MemberSettingNameMode, MemberUniqueInfoCollection, UpdatePersonalInfoRequest } from "kz-ui-sdk";

export const buildPersonalInfoRequest = (
  v: {
    firstName: string;
    lastName: string;
    accountName: string;
    pan?: string;
    cpf?: string;
    curp?: string;
  },
  nameMode?: MemberSettingNameMode | null,
): UpdatePersonalInfoRequest => {
  const info = {
    [MemberUniqueInfoCollection.PAN]: v.pan?.trim() || undefined,
    [MemberUniqueInfoCollection.CPF]: v.cpf?.trim() || undefined,
    [MemberUniqueInfoCollection.CURP]: v.curp?.trim() || undefined,
  };
  switch (nameMode) {
    case MemberSettingNameMode.FirstLast:
      return {
        firstname: v.firstName?.trim() || undefined,
        lastname: v.lastName?.trim() || undefined,
        info,
      };
    case MemberSettingNameMode.FullInFirst:
      return {
        firstname: v.accountName?.trim() || undefined,
        info,
      };
    default:
      return {
        firstname: v.firstName?.trim() || undefined,
        lastname: v.lastName?.trim() || undefined,
        info,
      };
  }
};
